import requester from '@/lib/axios';
import ExamArea, { ExamAreaDTO } from '@/models/ExamArea';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

export interface ExamAreaFilter extends BaseFilters {
  examId?: number;
  areaId?: number;
  studentExamId?: number;
}

const baseUrl = 'exam-areas';

export const listExamAreas = async (params: ExamAreaFilter = {}) => {
  const { data } = await requester().get<JsonApiResponse<ExamArea>>(
    `${baseUrl}/`,
    { params },
  );
  return data;
};

export const createExamArea = async (body: ExamAreaDTO) => {
  const { data } = await requester().post<ExamArea>(`${baseUrl}/`, body);
  return data;
};

export const deleteExamArea = async (examAreaId: number) => {
  await requester().delete<void>(`${baseUrl}/${examAreaId}/`);
};

export const reorderExamAreas = async (
  examId: number,
  examAreaIds: number[],
) => {
  await requester().patch<void>(
    `exams/${examId}/areas/order/`,
    examAreaIds.map(id => ({ id })),
  );
};
